import { useAuth } from '../utils/auth';

export function useApiAddReservation() {

  const auth = useAuth();
  const resource = auth.apiBaseUrl;

  const getConfigForUser = async function (impersonatedId) {

    impersonatedId = impersonatedId || {usr_id : 0};

    return fetch(resource + '/my_config', {
      signal : AbortSignal.timeout(30000),
      headers: {
        "Content-Type" : "application/json",
        "Authorization": "Bearer " + (auth.user ? auth.user.token : ""),
        "ImpersonatedId" :  impersonatedId.usr_id
      },
      method: "GET"
    }).then((res) => {
      if (res.ok) {                
        return res.json();
      } else if (res.status===401) {
        return {          
          returnCode : -401,
          returnMsg : "Accès non autorisé, vous devez vous connecter" //res.statusText
        }  ;        
      } else {  
        return {          
          returnCode : -2,
          returnMsg : res.statusText
        }  ;
      }      
    }).catch(error => {
      return {          
        returnCode : -500,            
        returnMsg : (error.response || error.request || error.message)
      }  
    })
  };

  const getAvailability = async function (dataToPost, impersonatedId) {

    impersonatedId = impersonatedId || {usr_id : 0};

    return fetch(resource + '/my_reservations/simulation', {
      signal : AbortSignal.timeout(30000),
      headers: {
        "Content-Type" : "application/json",
        "Authorization": "Bearer " + (auth.user ? auth.user.token : ""),
        "ImpersonatedId" :  impersonatedId.usr_id
      },
      method: "POST",
      body  : JSON.stringify(dataToPost)
    }).then((res) => {
      if (res.ok) {                
        return res.json();
      } else if (res.status===401) {
        return {          
          returnCode : -401,
          returnMsg : "Acces non autorisé, vous devez vous connecter" //res.statusText
        }  ;        
      } else {  
        return {          
          returnCode : -2,
          returnMsg : res.statusText
        }  ;
      }     
    }).catch(error => {
      return {          
        returnCode : -500,            
        returnMsg : (error.response || error.request || error.message)
      }        
    })
  };

  const confirmReservation = async function (dataToPost, impersonatedId) {

    impersonatedId = impersonatedId || {usr_id : 0};

    return fetch(resource + '/my_reservations', {
      signal : AbortSignal.timeout(30000),
      headers: {
        "Content-Type" : "application/json",
        "Authorization": "Bearer " + (auth.user ? auth.user.token : ""),
        "ImpersonatedId" :  impersonatedId.usr_id
      },
      method: "POST",
      body  : JSON.stringify(dataToPost)
    }).then((res) => {
      if (res.ok) {                
        return res.json();
      } else if (res.status===401) {
        return {          
          returnCode : -401,
          returnMsg : "Acces non autorisé, vous devez vous connecter" //res.statusText
        }  ;        
      } else {  
        return {          
          returnCode : -2,
          returnMsg : res.statusText
        }  ;
      }      
    }).catch(error => {
      return {          
        returnCode : -500,
        returnMsg : (error.response || error.request || error.message)
      }  ;      
    })
  };

  const removeReservation = async function(urvId) {

    return fetch(resource + '/my_reservations/' + urvId, {
      signal : AbortSignal.timeout(30000),
      headers: {
        "Content-Type" : "application/json",
        "Authorization": "Bearer " + (auth.user ? auth.user.token : "")                    
      },
      method: "DELETE"
    }).then((res) => {
      if (res.ok) {                
        return res.json();
      } else if (res.status===401) {
        return {          
          returnCode : -401,
          returnMsg : "Acces non autorisé, vous devez vous connecter" //res.statusText
        }  ;        
      } else {  
        return {          
          returnCode : -2,
          returnMsg : res.statusText
        }  ;
      }      
    }).catch(error => {
      return {          
        returnCode : -500,
        returnMsg : (error.response || error.request || error.message)
      }  ;      
    })

  };

  return {
    getConfigForUser,
    getAvailability,
    confirmReservation,
    removeReservation
  };
}
